import CryptoJS from 'crypto-js';
import { removeAll } from '../../utils/getLocalStorage';

const DecryptProjectData = () => {
    const superSecretKey = 'RamsInode2024';
    const data = localStorage.getItem("projectdetails") || localStorage.getItem("tpidetails");
    if(data){
      try {
          const bytes = CryptoJS.AES.decrypt(`${data}`, superSecretKey);
          const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
          return JSON.parse(decryptedData);
        } catch (error) {
          console.error('Decryption error:', error);
          return null;
        }
    } else {
    //   removeAll();
    }
}

export default DecryptProjectData;